export class TplValidationTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static validation = {
        mandatory: "Fält kan inte vara tomt"
    };
}
